// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-row >td{
    color: #424242 !important; 
    background: #EAEAEA !important;
    font-size:14px !important;
    height:31px !important;
}
.bg-grey{
    background: #EAEAEA !important;
}
.grey-42{
    color: #424242 !important; 
}
.grey-30{
    color: #303030 !important;;
}
.p-25{
    padding: 0.25rem 0.25rem !important;
}
.p-25-15{
    padding: 0.25rem 1.5rem !important;
}
.p-5-25{
    padding: 0.5rem 2.5rem !important; 
}
.p-25-5{
    padding: 0.25rem 0.5rem !important;
}
.w-1{
    width:1% !important;
    }
.w-2{
width:2% !important;
}
.w-3{
width:3% !important;
}
.w-4{
    width:4% !important;
    }
.w-45{
    width:4.5 !important;
}
.w-5{
    width:5% !important;
}
.w-6{
    width:6% !important;    
}
.w-7{
    width:7% !important;
}
.w-8{
width:8% !important;
}
.w-9{
width:9% !important;
}
.w-10{
    width:10% !important;
}
.w-11{
    width:11% !important;
}
.w-12{
    width:12% !important;
}
.w-13{
    width:13% !important;
}
.w-15{
    width:15% !important;
}
.w-18{
    width:18% !important;
}
.w-19{
    width:19% !important;
}
.w-20{
    width:20% !important;
}
.w-25{
    width:25% !important;
}
.w-27{
    width:27% !important;
}
.w-32{
    width:32% !important;
}
.w-33{
    width:33% !important;
}
.w-35{
    width:35% !important;
}
.w-40{
    width:40% !important;
}
.w-50{
    width:50% !important;
}
.w-60{
    width:60% !important;
}
.w-65{
    width:65% !important;
}
.w-70{
    width:70% !important;
}
.br-5{
    border-right: 0.5px solid #DCDCDC !important;
}
.competitionsInnerScroll{
    width:750px !important;
    max-width: 100% !important;
    overflow-x: auto !important;
}
@media only screen and (min-width: 1500px) {
    .competitionsInnerScroll{
        width:950px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Table.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mBAAmB;IACnB;AACJ;AACA,mBAAmB;AACnB;AACA;AACA,mBAAmB;AACnB;AACA;IACI,mBAAmB;IACnB;AACJ;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;AACA,mBAAmB;AACnB;AACA;AACA,mBAAmB;AACnB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,4CAA4C;AAChD;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".header-row >td{\n    color: #424242 !important; \n    background: #EAEAEA !important;\n    font-size:14px !important;\n    height:31px !important;\n}\n.bg-grey{\n    background: #EAEAEA !important;\n}\n.grey-42{\n    color: #424242 !important; \n}\n.grey-30{\n    color: #303030 !important;;\n}\n.p-25{\n    padding: 0.25rem 0.25rem !important;\n}\n.p-25-15{\n    padding: 0.25rem 1.5rem !important;\n}\n.p-5-25{\n    padding: 0.5rem 2.5rem !important; \n}\n.p-25-5{\n    padding: 0.25rem 0.5rem !important;\n}\n.w-1{\n    width:1% !important;\n    }\n.w-2{\nwidth:2% !important;\n}\n.w-3{\nwidth:3% !important;\n}\n.w-4{\n    width:4% !important;\n    }\n.w-45{\n    width:4.5 !important;\n}\n.w-5{\n    width:5% !important;\n}\n.w-6{\n    width:6% !important;    \n}\n.w-7{\n    width:7% !important;\n}\n.w-8{\nwidth:8% !important;\n}\n.w-9{\nwidth:9% !important;\n}\n.w-10{\n    width:10% !important;\n}\n.w-11{\n    width:11% !important;\n}\n.w-12{\n    width:12% !important;\n}\n.w-13{\n    width:13% !important;\n}\n.w-15{\n    width:15% !important;\n}\n.w-18{\n    width:18% !important;\n}\n.w-19{\n    width:19% !important;\n}\n.w-20{\n    width:20% !important;\n}\n.w-25{\n    width:25% !important;\n}\n.w-27{\n    width:27% !important;\n}\n.w-32{\n    width:32% !important;\n}\n.w-33{\n    width:33% !important;\n}\n.w-35{\n    width:35% !important;\n}\n.w-40{\n    width:40% !important;\n}\n.w-50{\n    width:50% !important;\n}\n.w-60{\n    width:60% !important;\n}\n.w-65{\n    width:65% !important;\n}\n.w-70{\n    width:70% !important;\n}\n.br-5{\n    border-right: 0.5px solid #DCDCDC !important;\n}\n.competitionsInnerScroll{\n    width:750px !important;\n    max-width: 100% !important;\n    overflow-x: auto !important;\n}\n@media only screen and (min-width: 1500px) {\n    .competitionsInnerScroll{\n        width:950px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
